import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { BeachClubPage } from './pages/BeachClubPage';
import { SUPPage } from './pages/SUPPage';
import { SUPRacePage } from './pages/SUPRacePage';
import { SUPToursPage } from './pages/SUPToursPage';
import { SurfskiPage } from './pages/SurfskiPage';
import { WingFoilPage } from './pages/WingFoilPage';
import { WingFoilCampaignPage } from './pages/WingFoilCampaignPage';
import { EventsPage } from './pages/EventsPage';
import { WaterTribeFestPage } from './pages/WaterTribeFestPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { TranzilaSuccessPage } from './pages/TranzilaSuccessPage';
import { AdminLogin } from './pages/AdminLogin';
import { AdminDashboard } from './pages/AdminDashboard';
import { FloatingJoinButton } from './components/FloatingJoinButton';
import { WorkshopRegistrationPage } from './pages/WorkshopRegistrationPage';
import { AdditionalPaymentPage } from './pages/AdditionalPaymentPage';
import { AdditionalPaymentThankYouPage } from './pages/AdditionalPaymentThankYouPage';
import { ResetRetreatPage } from './pages/ResetRetreatPage';
import { WindMeterPage } from './pages/WindMeterPage';
import { WomensSUPMorningPage } from './pages/WomensSUPMorningPage';
import { SafeSpaceOnWaterPage } from './pages/SafeSpaceOnWaterPage';
import { CorporateTeamBuildingPage } from './pages/CorporateTeamBuildingPage';
import { MensMorningOnWaterPage } from './pages/MensMorningOnWaterPage';
import { FlowAndPausePage } from './pages/FlowAndPausePage';
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    // Only scroll to top if there's no hash (like #contact)
    if (!hash) {
      // Force immediate scroll
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // Also use window.scrollTo as backup
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    }
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <Router data-id="element-0" data-mp="3uct3pkqacp10">
      <ScrollToTop data-id="element-1" data-mp="3ud1ff9ao9oam" />
      <Routes data-id="element-2" data-mp="3udkmtw2p4uae">
        <Route path="/" element={<BeachClubPage data-id="element-4" data-mp="3ucj8niqdvrog" />} data-id="element-3" data-mp="3ubzumd3utnfp" />
        <Route path="/sup" element={<SUPPage data-id="element-6" data-mp="d4xq9hl3gfef" />} data-id="element-5" data-mp="d4o09u01u88q" />
        <Route path="/sup-race" element={<SUPRacePage data-id="element-8" data-mp="d2bgrcen7ptk" />} data-id="element-7" data-mp="d45rxz0443kg" />
        <Route path="/sup-tours" element={<SUPToursPage data-id="element-10" data-mp="86w60tbxma1d" />} data-id="element-9" data-mp="851l3f0nuhxa" />
        <Route path="/surfski" element={<SurfskiPage data-id="element-12" data-mp="3gl4qtf87pwiz" />} data-id="element-11" data-mp="83i23gnmdsrt" />
        <Route path="/wingfoil" element={<WingFoilPage data-id="element-14" data-mp="3glo2ie79rook" />} data-id="element-13" data-mp="3gmfu7dxqx29k" />
        <Route path="/wingfoil-campaign" element={<WingFoilCampaignPage data-id="element-16" data-mp="3bnct24kvzg6v" />} data-id="element-15" data-mp="3bmbgfvo82ln1" />
        <Route path="/events" element={<EventsPage data-id="element-18" data-mp="3qaxu7sy7b5c5" />} data-id="element-17" data-mp="3bk720jsp648i" />
        <Route path="/water-tribe-fest" element={<WaterTribeFestPage data-id="element-20" data-mp="3qdakcte44m0a" />} data-id="element-19" data-mp="3qc95sexw1hdt" />
        <Route path="/thank-you" element={<ThankYouPage data-id="element-22" data-mp="3ljpj8sh83bwv" />} data-id="element-21" data-mp="3ljxvci5iud70" />
        <Route path="/tranzila-success" element={<TranzilaSuccessPage data-id="element-24" data-mp="2xud9nrhzh1u1" />} data-id="element-23" data-mp="3liedwo84pw3n" />
        <Route path="/admin/login" element={<AdminLogin data-id="element-26" data-mp="2xsk3edba8jmk" />} data-id="element-25" data-mp="2xtbzdp8skjdd" />
        <Route path="/admin" element={<AdminDashboard data-id="element-28" data-mp="2sv0odb6rg2tk" />} data-id="element-27" data-mp="2swbsjc44bcl7" />
        <Route path="/workshop-registration" element={<WorkshopRegistrationPage data-id="element-30" data-mp="18dhrg2sz2y5h" />} data-id="element-29" data-mp="2stpklbdbev2g" />
        <Route path="/additional-payment" element={<AdditionalPaymentPage data-id="element-32" data-mp="1d47xli983518" />} data-id="element-31" data-mp="18cgf7v0805m6" />
        <Route path="/additional-payment-thank-you" element={<AdditionalPaymentThankYouPage data-id="element-34" data-mp="yflk7m35oncn" />} data-id="element-33" data-mp="1d59l4m7fdjzu" />
        <Route path="/reset-retreat" element={<ResetRetreatPage data-id="element-36" data-mp="ydilmdnxtlwb" />} data-id="element-35" data-mp="ygwl9e57vh02" />
        <Route path="/wind-meter" element={<WindMeterPage data-id="element-38" data-mp="13fgabnf3x8wn" />} data-id="element-37" data-mp="13e54zj60jt3f" />
        <Route path="/womens-sup-morning" element={<WomensSUPMorningPage data-id="element-40" data-mp="1r3zhfzmf7fn5" />} data-id="element-39" data-mp="13clqny3x3s4a" />
        <Route path="/safe-space-on-water" element={<SafeSpaceOnWaterPage data-id="element-42" data-mp="1w33puo1it9cf" />} data-id="element-41" data-mp="1r4sf8b3eiut5" />
        <Route path="/team-building" element={<CorporateTeamBuildingPage data-id="element-44" data-mp="1w19d3x0eknjf" />} data-id="element-43" data-mp="1w2ao61hf5a15" />
        <Route path="/mens-morning-on-water" element={<MensMorningOnWaterPage data-id="element-46" data-mp="1i3b4774upjbb" />} data-id="element-45" data-mp="1i443xo5e78jy" />
        <Route path="/flow-and-pause" element={<FlowAndPausePage data-id="element-48" data-mp="1m3uy81u4o6t8" />} data-id="element-47" data-mp="1m4wag9mvqzcj" />
      </Routes>
      <ConditionalFloatingButton data-id="element-49" data-mp="1m70m5dr0t2nd" />
    </Router>;
}
function ConditionalFloatingButton() {
  const location = useLocation();
  // Don't show the general floating button on dedicated landing and payment pages
  if (location.pathname === '/water-tribe-fest' || location.pathname === '/thank-you' || location.pathname === '/tranzila-success' || location.pathname === '/additional-payment' || location.pathname === '/additional-payment-thank-you' || location.pathname === '/reset-retreat' || location.pathname === '/womens-sup-morning' || location.pathname === '/safe-space-on-water' || location.pathname === '/team-building' || location.pathname === '/wingfoil-campaign' || location.pathname === '/mens-morning-on-water' || location.pathname === '/flow-and-pause') {
    return null;
  }
  if (location.pathname === '/events') {
    return <FloatingJoinButton label="השאירו פרטים" data-id="element-50" data-mp="zx2b8hrkkjdz" />;
  }
  return <FloatingJoinButton data-id="element-51" data-mp="zzwrry7gpk24" />;
}